<div
  class="es-detail es-detail-desktop flex-column"
  [ngClass]="{
    'is-opened': isShowDetails,
    united: es.isUnitedStatement,
    lastUnited: es.isUnitedStatement && (lastShown || es.isLastUnited),
    firstUnited: es.isUnitedStatement && es.isFirstUnited
  }"
>
  <div class="es-detail-header">
    <div class="es-detail-col-display-part">
      <div class="es-detail-chevron d-flex">
        <div
          class="es-detail-chevron-icon"
          nz-popover
          nzPopoverOverlayClassName="tooltip-sm"
          nzPopoverTrigger="hover"
          [ngClass]="{ 'is-opened': isShowDetails }"
          [nzPopoverContent]="(isShowDetails ? 'BUTTON.CLOSE' : 'BUTTON.SEE_MORE') | translate"
          (click)="isShowDetails = !isShowDetails"
        >
          <img src="/assets/icons/icon_chevron_down_gray.svg" />
        </div>
      </div>
      <div class="es-detail-icon d-flex">
        <img *ngIf="es.transportationMode === enumESTransportationMode.AIR" class="icon-type" src="/assets/icons/icon_plain.svg" />
        <img *ngIf="es.transportationMode === enumESTransportationMode.OCEAN" class="icon-type" src="/assets/icons/icon_vessel.svg" />
        <img *ngIf="es.transportationMode === enumESTransportationMode.RAIL" class="icon-type" src="/assets/icons/rail.svg" />
        <img *ngIf="es.transportationMode === enumESTransportationMode.TRUCK" class="icon-type" src="/assets/icons/icon_truck_md.svg" />
      </div>
      <div class="row col align-items-center">
        <div class="es-detail-col es-detail-name" [routerLink]="['/entry-summary', es.referenceNumber]">
          <div class="d-flex flex-column align-items-start">
            <a class="btn btn-link">{{ es.referenceNumber }}</a>
            <span class="es-detail-transaction-number" *ngIf="!!es.entryNumber">{{ es.entryNumber }}</span>
          </div>
        </div>

        <div
          class="es-detail-col es-detail-from-to d-flex flex-column justify-content-center"
          [routerLink]="['/entry-summary', es.referenceNumber]"
        >
          <div>{{ es?.from?.[0]?.code }} {{ es?.from?.[0]?.countryName }}</div>
          <div>{{ es?.portOfUnlading?.code }} {{ es?.portOfUnlading?.description }}</div>
        </div>

        <div class="es-detail-col es-detail-arrival-date" [routerLink]="['/entry-summary', es.referenceNumber]">
          <span>{{ es.arrivalDate | customDateByUtc }}</span>
        </div>

        <div
          class="es-detail-col es-detail-calculations d-flex flex-column justify-content-center"
          [routerLink]="['/entry-summary', es.referenceNumber]"
        >
          <span>{{ es.goodsValue | currency : "USD" : "symbol" : "1.2-2" }}</span>
          <span class="es-detail-calculations-duties">{{ es.estimatedDuties | currency : "USD" : "symbol" : "1.2-2" }}</span>
        </div>

        <div class="es-detail-col es-detail-status" [routerLink]="['/entry-summary', es.referenceNumber]">
          <es-status
            [submissionType]="es.submissionType"
            [state]="es.state"
            [paymentState]="es.paymentState"
            [customState]="es.customState"
          ></es-status>
        </div>
      </div>

      <div class="justify-content-end pr-0 es-detail-col es-detail-actions">
        <ng-container [ngTemplateOutlet]="actionIcons"></ng-container>

        <es-actions
          [es]="es"
          [state]="es.state"
          [paymentState]="es.paymentState"
          [showDelivery]="false"
          [showInList]="true"
          (update)="afterDeleteES()"
        ></es-actions>
      </div>
    </div>
  </div>

  <div class="container es-detail-body" *ngIf="isShowDetails">
    <div class="es-detail-body-card">
      <div class="es-detail-body-card-header">
        <h5>
          {{ "LABELS.BILL_OF_LADING_DETAILS" | translate }}
          <ng-container *ngIf="es?.shipments?.length > 2">
            ({{ isShowAllBills ? es?.shipments?.length : 2 }}/{{ es?.shipments?.length }})
          </ng-container>
        </h5>
        <div class="d-flex align-items-center cursor-pointer" *ngIf="es?.shipments?.length > 2" (click)="isShowAllBills = !isShowAllBills">
          <span class="action-label pr-1">{{ (isShowAllBills ? "LABELS.HIDE_DETAILS" : "LABELS.SEE_ALL") | translate }}</span>
          <img src="assets/icons/icon_chevron_up.svg" />
        </div>
      </div>

      <div class="es-detail-body-card-notification" *ngIf="!isValidShipment">
        {{ "LABELS.SOME_OF_THE_DETAILS_ARE_MISSING" | translate }}
      </div>

      <div
        class="es-detail-body-card-col-wrapper"
        [ngClass]="{ 'has-notes-box': !!es.internalReferenceNumber || !!es.internalNotes }"
        *ngFor="let shipment of isShowAllBills ? es.shipments : entryShipments"
      >
        <div class="es-detail-body-card-col">
          <h6>{{ "FORM_LABEL.MASTER_BILL_OF_LADING" | translate }}</h6>

          <p *ngIf="!!shipment.masterBill?.carrier && !!shipment.masterBill?.number">
            {{ shipment.masterBill?.carrier }} {{ shipment.masterBill?.number }}
          </p>
          <p class="text-error" *ngIf="!shipment.masterBill?.carrier && !shipment.masterBill?.number">
            {{ "BACK_ERROR.MISSING" | translate }}
          </p>
        </div>

        <div class="es-detail-body-card-col" *ngIf="!isTruck">
          <h6>{{ "FORM_LABEL.HOUSE_BILL_OF_LADING" | translate }}</h6>

          <p *ngIf="!!shipment.houseBill?.carrier && !!shipment.houseBill?.number">
            {{ shipment.houseBill?.carrier }} {{ shipment.houseBill?.number }}
          </p>
          <p class="text-error" *ngIf="!shipment.houseBill?.carrier && !shipment.houseBill?.number">
            {{ "BACK_ERROR.MISSING" | translate }}
          </p>
        </div>

        <div class="es-detail-body-card-col">
          <h6>{{ "INFO.SE.TITLE" | translate }}</h6>
          <p>{{ shipment.seller?.name }}</p>
        </div>
      </div>
    </div>

    <div class="es-detail-body-card" *ngIf="!!es.internalReferenceNumber || !!es.internalNotes">
      <div class="es-detail-body-card-header">
        <h5>
          {{ "LABELS.INTERNAL_NOTES" | translate }}

          <span>{{ "LABELS.INTERNAL_NOTES_MESSAGE" | translate }}</span>
        </h5>

        <button type="button" class="btn btn-link btn-edit-pencil" (click)="editInternalNotes.emit()"></button>
      </div>

      <div class="es-detail-body-card-col-wrapper notes-box">
        <div class="es-detail-body-card-col notes-col" *ngIf="!!es.internalReferenceNumber">
          <h6>{{ "LABELS.INTERNAL_REFERENCE_NUMBER" | translate }}</h6>
          <p>{{ es.internalReferenceNumber }}</p>
        </div>

        <div class="es-detail-body-card-col notes-col" *ngIf="!!es.internalNotes">
          <h6>{{ "LABELS.NOTES" | translate }}</h6>
          <p>{{ es.internalNotes }}</p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="es.isUnitedStatement && (lastShown || es.isLastUnited)" class="es-statement-detail row w-100 d-lg-flex d-none mt-4">
    <div class="col">
      <div>
        <div
          *ngIf="es.statement.state === enumESStatementState.CREATED"
          [innerHTML]="'ENTRY_SUMMARY.STATEMENT_MESSAGES.CREATED_SHORT' | translate"
        ></div>
        <div
          *ngIf="es.statement.state === enumESStatementState.AUTHORIZATION_PENDING"
          [innerHTML]="'ENTRY_SUMMARY.STATEMENT_MESSAGES.AUTHORIZATION_PENDING' | translate"
        ></div>
        <div
          *ngIf="es.statement.state === enumESStatementState.AUTHORIZATION_SENT"
          [innerHTML]="'ENTRY_SUMMARY.STATEMENT_MESSAGES.AUTHORIZATION_SENT' | translate"
        ></div>
        <div
          *ngIf="es.statement.state === enumESStatementState.AUTHORIZATION_COMPLETED"
          [innerHTML]="'ENTRY_SUMMARY.STATEMENT_MESSAGES.AUTHORIZATION_COMPLETED' | translate"
        ></div>
        <div
          *ngIf="es.statement.state === enumESStatementState.AUTHORIZATION_REJECTED"
          [innerHTML]="'ENTRY_SUMMARY.STATEMENT_MESSAGES.AUTHORIZATION_REJECTED' | translate"
        ></div>
        <div
          *ngIf="es.statement.state === enumESStatementState.CHARGED"
          [innerHTML]="'ENTRY_SUMMARY.STATEMENT_MESSAGES.CHARGED' | translate"
        ></div>
      </div>
      <div class="row mt-3 align-items-center">
        <div
          class="field"
          [ngClass]="{
            'col-3': showAuthorizedDate || showPaidDate,
            'col-4': !showAuthorizedDate && !showPaidDate
          }"
        >
          <span class="label pr-1">{{ "LABELS.STATEMENT_NUMBER" | translate }}:</span>
          <span class="value">{{ es.statement.statementNumber }}</span>
        </div>
        <div
          *ngIf="showReleasedDate"
          class="field"
          [ngClass]="{
            'col-3': showAuthorizedDate || showPaidDate,
            'col-4': !showAuthorizedDate && !showPaidDate
          }"
        >
          <span class="label pr-1">{{ "LABELS.RELEASED" | translate }}:</span>
          <span class="value">{{ es.releaseDate | customDateByUtc }}</span>
        </div>
        <div
          *ngIf="!showReleasedDate"
          class="field"
          [ngClass]="{
            'col-3': showAuthorizedDate || showPaidDate,
            'col-4': !showAuthorizedDate && !showPaidDate
          }"
        >
          <span class="label pr-1">{{ "LABELS.PRINT_DATE" | translate }}:</span>
          <span class="value">{{ es.statement.printDate | customDateByUtc }}</span>
        </div>
        <div
          class="field"
          [ngClass]="{
            'col-3': showAuthorizedDate || showPaidDate,
            'col-4': !showAuthorizedDate && !showPaidDate
          }"
        >
          <span class="label-total pr-1">{{ "LABELS.DUTIES_AND_FEES" | translate }}:</span>
          <span class="value value-total-sum">{{ es.statement.amount | currency : "USD" : "symbol" : "1.2-2" }}</span>
        </div>
        <div class="col-3 field" *ngIf="showPaidDate">
          <span class="label-total pr-1">{{ "LABELS.PAID_DATE" | translate }}:</span>
          <span class="value value-total">{{ es.statement.paidDate | customDateByUtc }}</span>
        </div>
        <div class="col-3 field" *ngIf="showAuthorizedDate">
          <span class="label-total pr-1">{{ "LABELS.AUTHORIZED_DATE" | translate }}:</span>
          <span class="value value-total">
            {{ es.statement.authorizedDate ? (es.statement.authorizedDate | customDateByUtc) : ("LABELS.NOT_AVAILABLE" | translate) }}
          </span>
        </div>
      </div>
    </div>
    <div
      *ngIf="es.statement.state === enumESStatementState.CREATED"
      class="col-3 pl-3 pr-4 flex-shrink-0 left-part d-flex align-items-center"
    >
      <button class="btn btn-primary" [routerLink]="['/prelimetary-statement', es.statement.id]">
        {{ "BUTTON.AUTHORIZE_STATEMENT" | translate }}
      </button>
    </div>
  </div>
</div>

<div
  class="es-detail es-detail-mobile"
  [ngClass]="{
    united: es.isUnitedStatement,
    lastUnited: es.isUnitedStatement && (lastShown || es.isLastUnited),
    firstUnited: es.isUnitedStatement && es.isFirstUnited
  }"
>
  <div class="container">
    <div class="row">
      <div class="col-12 es-detail-header" [routerLink]="['/entry-summary', es.referenceNumber]">
        <div class="row">
          <div class="col-12">
            <div class="w-100 d-flex justify-content-start align-items-center mb-3 es-detail-name">
              <div class="row">
                <div class="col-3">
                  <img
                    *ngIf="es.transportationMode === enumESTransportationMode.AIR"
                    class="icon-type"
                    src="/assets/icons/icon_plain.svg"
                  />
                  <img
                    *ngIf="es.transportationMode === enumESTransportationMode.OCEAN"
                    class="icon-type"
                    src="/assets/icons/icon_vessel.svg"
                  />
                  <img
                    *ngIf="es.transportationMode === enumESTransportationMode.RAIL"
                    class="icon-type mw-100"
                    src="/assets/icons/rail.svg"
                  />
                  <img
                    *ngIf="es.transportationMode === enumESTransportationMode.TRUCK"
                    class="icon-type mw-100"
                    src="/assets/icons/icon_truck.svg"
                  />
                </div>

                <div class="col-9">
                  <a class="btn btn-link mr-3">{{ es.referenceNumber }}</a>
                </div>
              </div>
              <span class="es-detail-transaction-number" *ngIf="!!es.entryNumber">{{ es.entryNumber }}</span>
            </div>
          </div>

          <div class="col-12 d-flex">
            <es-status
              [submissionType]="es.submissionType"
              [state]="es.state"
              [paymentState]="es.paymentState"
              [customState]="es.customState"
            ></es-status>
          </div>
        </div>
      </div>

      <div class="col-12 es-detail-body" [routerLink]="['/entry-summary', es.referenceNumber]">
        <div class="row" *ngIf="!isTruck">
          <div class="col-4">
            <span class="es-detail-body-header">{{ "LABELS.FROM" | translate }}</span>
          </div>
          <div class="col-8">
            <div>{{ es?.from?.[0]?.code }} {{ es?.from?.[0]?.countryName }}</div>
            <strong *ngIf="!es?.from?.[0]?.code || !es?.from?.[0]?.countryName" class="btn-link">
              {{ "LABELS.REQUIRED" | translate }}
            </strong>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <span class="es-detail-body-header">{{ "LABELS.TO" | translate }}</span>
          </div>
          <div class="col-8">
            <div>{{ es?.portOfUnlading?.code }} {{ es?.portOfUnlading?.description }}</div>
            <strong *ngIf="!es?.portOfUnlading?.code || !es?.portOfUnlading?.description" class="btn-link">
              {{ "LABELS.REQUIRED" | translate }}
            </strong>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <span class="es-detail-body-header">{{ "LABELS.ARRIVAL_DATE" | translate }}</span>
          </div>
          <div class="col-8">
            <div>{{ es?.arrivalDate | customDateByUtc }}</div>
            <strong *ngIf="!es?.arrivalDate" class="btn-link">{{ "LABELS.REQUIRED" | translate }}</strong>
          </div>
        </div>

        <div class="row" *ngIf="!!es?.goodsValue">
          <div class="col-4">
            <span class="es-detail-body-header">{{ "LABELS.GOODS_VALUE" | translate }}</span>
          </div>
          <div class="col-8">
            <div>{{ es?.goodsValue | currency : "USD" : "symbol" : "1.2-2" }}</div>
          </div>
        </div>

        <div class="row" *ngIf="!!es?.estimatedDuties">
          <div class="col-4">
            <span class="es-detail-body-header">{{ "LABELS.DUTIES_AND_FEES" | translate }}</span>
          </div>
          <div class="col-8">
            <div class="es-detail-body-duties">{{ es?.estimatedDuties | currency : "USD" : "symbol" : "1.2-2" }}</div>
          </div>
        </div>
      </div>

      <div class="col-12 es-detail-footer">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ "LABELS.ACTIONS" | translate }}</span>

          <ng-container [ngTemplateOutlet]="actionIcons"></ng-container>

          <es-actions
            [es]="es"
            [state]="es.state"
            [paymentState]="es.paymentState"
            [showDelivery]="false"
            [showInList]="true"
            (update)="afterDeleteES()"
          ></es-actions>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actionIcons>
  <ng-container *ngIf="isShowInsuranceIndicator">
    <app-marine-insurance-indicator
      [entityReferenceNumber]="es.referenceNumber"
      entityRedirectPath="/entry-summary"
      [companyPlacement]="enumCompanyPlacement.ENTRY_SUMMARY"
      [entityStatus]="es?.insuranceStatus"
    ></app-marine-insurance-indicator>
  </ng-container>

  <img
    src="/assets/icons/icon_delivery_order_gray.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'LABELS.CREATE_DELIVERY_ORDER' | translate"
    [routerLink]="['/entry-summary', es.referenceNumber, 'delivery-order']"
    *ngIf="!es.deliveryOrdersCount && es.transportationMode !== enumESTransportationMode.TRUCK"
  />

  <div
    class="es-icon-delivery-order"
    *ngIf="!!es.deliveryOrdersCount && es.transportationMode !== enumESTransportationMode.TRUCK"
    [routerLink]="['/entry-summary', es.referenceNumber, 'delivery-order']"
  >
    <span class="es-icon-delivery-order-count">{{ es.deliveryOrdersCount }}</span>

    <div class="d-none d-lg-block">
      <img
        src="/assets/icons/icon_delivery_order_green.svg"
        nz-popover
        nzPopoverOverlayClassName="tooltip-sm"
        nzPopoverTrigger="hover"
        [nzPopoverContent]="'MENU.DELIVERY_ORDER' | translate"
      />
    </div>

    <div class="d-lg-none">
      <img
        src="/assets/icons/icon_delivery_order_mobile_green.svg"
        nz-popover
        nzPopoverOverlayClassName="tooltip-sm"
        nzPopoverTrigger="hover"
        [nzPopoverContent]="'MENU.DELIVERY_ORDER' | translate"
      />
    </div>
  </div>

  <img
    src="/assets/icons/icon_note_gray.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'LABELS.INTERNAL_NOTES_ADD' | translate"
    *ngIf="!es.internalReferenceNumber && !es.internalNotes"
    (click)="editInternalNotes.emit()"
  />
  <img
    src="/assets/icons/icon_note_green.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'LABELS.INTERNAL_NOTES_EDIT' | translate"
    *ngIf="!!es.internalReferenceNumber || !!es.internalNotes"
    (click)="editInternalNotes.emit()"
  />

  <ng-container *ngIf="showBrokerMessages">
    <img
      src="/assets/icons/icon_mail_gray.svg"
      nz-popover
      nzPopoverOverlayClassName="tooltip-sm"
      nzPopoverTrigger="hover"
      [nzPopoverContent]="'LABELS.MESSAGE_TO_BROKER' | translate"
      *ngIf="!es.hasNewBrokerMessages"
      (click)="openChat.emit()"
    />
    <div
      class="broker-message-icon"
      nz-popover
      nzPopoverOverlayClassName="tooltip-sm"
      nzPopoverTrigger="hover"
      [nzPopoverContent]="'LABELS.SEE_MESSAGE' | translate"
      *ngIf="!!es.hasNewBrokerMessages"
      (click)="openChat.emit()"
    >
      <img src="/assets/icons/icon_mail_notification.svg" />
      <span class="broker-message-badge">1</span>
    </div>
  </ng-container>
</ng-template>
